import React from "react";
import classnames from "classnames";
import { GeneralIcon } from "modules/common/components/planr/icon/Generalcon";
import styles from "./PlanrCheckbox.module.scss";

/**
 * Фирменный чекбокс: иконки general-checkbox / general-zero-checkbox из спрайта вместо
 * чекбокса Blueprint. Кликабелен целиком вместе с подписью, управляется с клавиатуры
 * (пробел/Enter — это нативная кнопка с role="checkbox").
 */
export const PlanrCheckbox = ({
    checked,
    onChange,
    children,
    disabled,
    size = 18,
    className,
    title,
}: PlanrCheckboxProps) => (
    <button
        type="button"
        role="checkbox"
        aria-checked={checked}
        disabled={disabled}
        title={title}
        className={classnames(styles.checkbox, { [styles.checked]: checked }, className)}
        onClick={() => onChange(!checked)}
    >
        <GeneralIcon
            type={checked ? "general-checkbox" : "general-zero-checkbox"}
            size={size}
            className={styles.icon}
        />
        {children !== undefined && <span className={styles.label}>{children}</span>}
    </button>
);

interface PlanrCheckboxProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    children?: React.ReactNode;
    disabled?: boolean;
    /** Размер иконки, px */
    size?: number;
    className?: string;
    title?: string;
}
